module.exports = __webpack_public_path__ + "static/media/PDF_126.166c4583.pdf";